import { Box, Typography } from "@mui/material";

export const IconTab = ({ iconPath, text }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        height: "4.63rem",
        background: "rgba(110, 177, 217, 0.2)",
        borderRadius: "40px",
        paddingX: "1rem",
      }}
    >
      {/* Círculo del ícono */}
      <Box
        sx={{
          width: 75,
          height: 75,
          borderRadius: "50%", // ✅ círculo perfecto
          background: "#6EB1D9",
          display: "flex", // ✅ centra la imagen
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0, // evita que flex lo deforme
          marginLeft: "-1rem"
        }}
      >
        <Box
          component="img"
          src={iconPath}
          alt="icono"
          sx={{
            width: "55%", // proporcional
            height: "auto",
            objectFit: "contain",
          }}
        />
      </Box>

      {/* Texto */}
      <Typography
        sx={{
          color: "#FFF",
          fontFamily: "Montserrat",
          fontWeight: 700,
          lineHeight: "162.5%",
          letterSpacing: "-0.1px",
          textAlign: { xs: "left", sm: "left" },
          marginLeft: "1.25rem",
          fontSize: {
            xs: "14px",  // 📱 móviles
            sm: "16px",  // 🧩 tablets
            md: "18px",  // 💻 pantallas medianas
            lg: "21px",  // 🖥️ pantallas grandes
          },
        }}
      >
        {text}
      </Typography>
    </Box>
  );
};
